import {AfterViewInit, Component, OnDestroy, QueryList, ViewChildren} from '@angular/core';
import {BuildingModel} from '../../../../models/data-models/building-model';
import {NgModel} from '@angular/forms';
import {Subscription} from 'rxjs';
import {ShareService} from "../../../../services/share.service";
import {ValidationService} from "../../../../services/validation.service";
import {debounceTime} from "rxjs/operators";

@Component({
  selector: 'app-install-building',
  templateUrl: './install-building.component.html',
  styleUrls: ['./install-building.component.scss'],

})
export class InstallBuildingComponent implements AfterViewInit, OnDestroy {
  public model: BuildingModel;

  @ViewChildren(NgModel) inputs: QueryList<NgModel>;

  private inputSubscriptions: Subscription[] = [];
  private modelSubscription: Subscription;

  constructor(
    private shareService: ShareService,
    public validationService: ValidationService,
  ) {
    this.model = this.shareService.building || new BuildingModel();
    this.modelSubscription = this.shareService.building$.subscribe((data) => {
      this.model = data || new BuildingModel();
    });
  }

  ngAfterViewInit(): void {
    this.inputs.forEach(input => {
      this.inputSubscriptions.push(input.control.valueChanges.pipe(
        debounceTime(500)
      ).subscribe(() => {
        this.shareService.building = this.model;
      }));
    });

    // Subscribe to changes in the list of inputs
    // (it is called if some input is added or removed from the form/page,
    // for example, because of *ngIf condition changes)
    this.inputs.changes.subscribe(() => {
      // Unsubscribe from old subscriptions
      this.inputSubscriptions.forEach(subscription => subscription.unsubscribe());

      // Subscribe to new inputs
      this.inputs.forEach(input => {
        this.inputSubscriptions.push(input.control.valueChanges.pipe(
          debounceTime(500)
        ).subscribe(() => {
          this.shareService.building = this.model;
        }));
      });
    });
  }

  ngOnDestroy(): void {
    this.inputSubscriptions.forEach(subscription => subscription.unsubscribe());
    if (this.modelSubscription) {
      this.modelSubscription.unsubscribe();
    }
  }
}
